export const STORAGE_KEYS = {
	CREDIT_LIMIT: 'banner-dismissed-bannerId:credit-limit',
	// add more fixed keys here
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
